module.exports = __webpack_public_path__ + "static/media/iStock-488052330.5556ab96.jpg";